// get fields
export function getFormFields(formEl, fields) {
  var formEl    = $(formEl);
  var fieldEls  = formEl.find('[data-field]');
	var fields    = [];
	
  for(var i = 0; i < fieldEls.length; i++){
    var fieldEl = $(fieldEls[i]);

    fields[fieldEl.attr('data-field')] = fieldEl;
  }

  return fields;
}

// form validar
export function formValidation(errors, messages, formEl) {
	// get fields
	var formEl = $(formEl);
	var fields = getFormFields(formEl);

	// error and info elems
	var errorsEl   = formEl.find('.form__errors');
	var messagesEl = formEl.find('.form__messages');

	// error and info messages
	var errorMessages = [];

	// clear everything on submit
	formEl.removeClass('form--errors');
	errorsEl.html('').hide();
	messagesEl.html('').hide();

	for(var key in fields) {
		fields[key].removeClass('error');
	}

	// errors
	for(var key in errors) {
		var error = errors[key];

		// hightlight field 
		if(fields[key]) fields[key].addClass('error');

		// if there is attached message add it to messages
		if(error){
			formEl.addClass('form--errors');
			errorMessages[key] = error;
		}
	}

	// show errors
	for(var key in errorMessages) {
		errorsEl.show();
		errorsEl.append('<div class="form__error">' + errorMessages[key] + '</div>')
	}

	// success messages
	if(messages) {
		messagesEl.show();

		// add messages
		for(var key in messages) {
			var message = messages[key];

			messagesEl.append('<div class="form__message form__message--' + key + '">' + message + '</div>');
		}
	}
}

// get array value
export function getArrayValue(inputEls) {
	return inputEls.map(function(){ return this.value; }).get();
}